var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffersWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_8219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.166 9.99998C19.166 8.58331 18.166 7.41663 16.8327 7.16663C17.5827 5.99996 17.416 4.49994 16.416 3.49994C15.416 2.49994 13.916 2.41661 12.7493 3.08327C12.4993 1.74994 11.3327 0.75 9.91601 0.75C8.49934 0.75 7.33268 1.74994 7.08268 3.08327C5.91601 2.33327 4.41602 2.49994 3.41602 3.49994C2.41602 4.49994 2.33268 5.99996 2.99935 7.16663C1.66602 7.41663 0.666016 8.58331 0.666016 9.99998C0.666016 11.4166 1.66602 12.5833 2.99935 12.8333C2.24935 14 2.41602 15.5 3.41602 16.5C4.41602 17.5 5.91601 17.5834 7.08268 16.9167C7.33268 18.25 8.49934 19.25 9.91601 19.25C11.3327 19.25 12.4993 18.25 12.7493 16.9167C13.916 17.6667 15.416 17.5 16.416 16.5C17.416 15.5 17.4993 14 16.8327 12.8333C18.166 12.5833 19.166 11.4166 19.166 9.99998Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 7.41699L9.16602 12.417L6.66602 9.91699",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_8219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersWhite);
export default __webpack_public_path__ + "static/media/Offers_White.78d63c1f55a9032fb4ff57512138e021.svg";
export { ForwardRef as ReactComponent };